(() => {
  const root = document.querySelector('.gf-policy-page');
  if (!root) return;
  const header = document.querySelector('[data-gf-store-header]');
  const offset = () => root.style.setProperty('--gf-policy-header', `${header ? Math.ceil(header.getBoundingClientRect().height) : 0}px`);
  offset();
  if (header && typeof ResizeObserver === 'function') new ResizeObserver(offset).observe(header);
  const standardPolicy = /\/policies\/(refund-policy|shipping-policy)\/?$/.test(location.pathname);
  const body = root.querySelector('.shopify-policy__body .rte');
  if (standardPolicy && body) {
    body.classList.add('gf-policy-standard-body');
    body.querySelectorAll(':scope > p').forEach(paragraph => {
      const first = [...paragraph.childNodes].find(node => node.nodeType === Node.TEXT_NODE ? node.textContent.trim() : node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'BR');
      if (first?.nodeType !== Node.ELEMENT_NODE || !['STRONG','B'].includes(first.tagName)) return;
      if (paragraph === body.firstElementChild && /Last updated:/.test(paragraph.textContent)) {
        paragraph.classList.add('gf-policy-document-meta');
        return;
      }
      const heading = document.createElement('h3');
      heading.className = 'gf-policy-section-heading';
      while (paragraph.firstChild !== first) heading.append(paragraph.firstChild);
      heading.append(first);
      paragraph.before(heading);
    });
    body.querySelectorAll('li').forEach(item => {
      const children = [...item.children];
      if (children.length === 1 && children[0].tagName === 'P') children[0].replaceWith(...children[0].childNodes);
    });
  }
  root.querySelectorAll('.shopify-policy__body .rte p, .rich-text__text p').forEach(paragraph => {
    if (!paragraph.textContent.trim() && !paragraph.querySelector('img,iframe,video,svg,input')) paragraph.classList.add('gf-policy-spacer');
    if (paragraph.closest('li') || paragraph.classList.contains('gf-policy-document-meta')) return;
    const first = [...paragraph.childNodes].find(node => node.nodeType === Node.TEXT_NODE ? node.textContent.trim() : node.nodeType === Node.ELEMENT_NODE && node.tagName !== 'BR');
    if (first?.nodeType === Node.ELEMENT_NODE && ['STRONG','B'].includes(first.tagName)) first.classList.add('gf-policy-inline-heading');
  });
})();
